import React, { useState } from "react";
import { styles } from "../styles/theme";

// Contraseña del administrador (en producción debería estar en variables de entorno)
const ADMIN_PASSWORD = "izanagi01";

function AdminLoginPage({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      onLogin();
    } else {
      setError("Contraseña incorrecta");
      setPassword("");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>🔐 Acceso Administrador</h1>
        <p style={styles.subtitle}>Introduce la contraseña de administrador</p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Contraseña</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Ingresa la contraseña"
            autoFocus
          />
          
          {error && (
            <p style={loginStyles.error}>{error}</p>
          )}

          <button style={styles.button} type="submit">
            Ingresar
          </button>
        </form>
      </div>
    </div>
  );
}

const loginStyles = {
  error: {
    color: "#ff8888",
    fontSize: 12,
    marginTop: 4,
    marginBottom: 8,
  },
  hint: {
    fontSize: 11,
    color: "#A8D5FF",
    marginTop: 16,
    textAlign: "center",
    opacity: 0.7,
  },
};

export default AdminLoginPage;
